import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: 0, // Removemos el padding para que el encabezado sea full width
    maxWidth: '100%',
    margin: '0 auto'
  },
  // Nuevo estilo para el encabezado full width
  productInfoHeader: {
    marginBottom: theme.spacing(3),
    backgroundColor: theme.palette.grey[50],
    width: '100%'
  },
  // Contenedor para el resto del contenido con padding
  content: {
    padding: 0
  },
  formContainer: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.default
  },
  formField: {
    marginBottom: theme.spacing(2)
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2)
  },
  tableContainer: {
    marginTop: theme.spacing(3)
  },
  title: {
    marginBottom: theme.spacing(2),
    fontWeight: 600
  },
  emptyState: {
    textAlign: 'center',
    padding: theme.spacing(4),
    color: theme.palette.text.secondary
  },
  tableHeader: {
    backgroundColor: theme.palette.grey[100],
    fontWeight: 600
  },
  actionButtons: {
    display: 'flex',
    gap: theme.spacing(1),
    justifyContent: 'center'
  },
  summaryBox: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.info.light,
    color: theme.palette.info.contrastText
  },
  counterContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    border: `2px solid ${theme.palette.divider}`
  },
  counterBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  counterValue: {
    fontSize: '1.5rem',
    fontWeight: 700,
    color: theme.palette.primary.main
  },
  counterValueWarning: {
    fontSize: '1.5rem',
    fontWeight: 700,
    color: theme.palette.warning.main
  },
  counterValueDanger: {
    fontSize: '1.5rem',
    fontWeight: 700,
    color: theme.palette.error.main
  },
  counterValueSuccess: {
    fontSize: '1.5rem',
    fontWeight: 700,
    color: theme.palette.success.main
  },
  counterLabel: {
    fontSize: '0.875rem',
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  divider: {
    width: 2,
    height: 60,
    backgroundColor: theme.palette.divider
  },
  statusChip: {
    fontWeight: 600
  },
  // Botón de guardar al final
  buttonFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(3),
    paddingTop: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`
  },
  cancelButton: {
    marginRight: theme.spacing(1)
  }
}))
